import { gsap } from './cco-gsap-core';

const linkArrowAnimations = () => {
  const arrowLinks = document.querySelectorAll('.arrow-link');

  console.log(arrowLinks);

  arrowLinks.forEach(link => {
    const arrow = link.querySelector('.link-arrow');
    if (!arrow) return;
    const line = arrow.querySelector('.line');
    if (!line) return;

    const arrowPointer = arrow.querySelector('.arrow')
    const circle = arrow.querySelector('.circle')
    const heart = arrow.querySelector('.heart')

    // GSAP timeline for line animation
    const tl = gsap.timeline({ paused: true });

    gsap.set(arrowPointer, { transformOrigin: '100% 50%', scale: 1 });
    gsap.set(heart, { x: '-14px'})

    tl.to(line, {
      attr: { x2: '50.4191427' },
      duration: 0.4,
      ease: 'power2.out'
    }, 0);

    tl.to(arrowPointer, {
      x: '12px',
      scale: 0.5,
      strokeWidth: 2,
      duration: 0.4,
      ease: 'power2.out'
    }, 0);

    tl.to(circle, {
      x: '14px',
      opacity: 0,
      duration: 0.4,
      ease: 'power2.out'
    }, 0);

    tl.to(heart, {
      x: '0px',
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out'
    }, 0);

    link.addEventListener('mouseenter', () => {
      tl.play();
    });
    link.addEventListener('mouseleave', () => {
      tl.reverse();
    });
  });
}

export const initializePageAnimations = () => {
  linkArrowAnimations();
}